var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.219,
    viewBox: "0 0 16 14.219",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.183,2.315l2.506,2.506a.272.272,0,0,1,0,.383L7.622,11.271l-2.578.286a.54.54,0,0,1-.6-.6l.286-2.578L10.8,2.315A.272.272,0,0,1,11.183,2.315Zm4.5-.636L14.328.324a1.086,1.086,0,0,0-1.533,0l-.983.983a.272.272,0,0,0,0,.383L14.317,4.2a.272.272,0,0,0,.383,0l.983-.983a1.086,1.086,0,0,0,0-1.533ZM10.667,9.621v2.828H1.778V3.56H8.161a.342.342,0,0,0,.236-.1L9.508,2.351a.333.333,0,0,0-.236-.569H1.333A1.334,1.334,0,0,0,0,3.115v9.778a1.334,1.334,0,0,0,1.333,1.333h9.778a1.334,1.334,0,0,0,1.333-1.333V8.51a.334.334,0,0,0-.569-.236L10.764,9.385A.342.342,0,0,0,10.667,9.621Z",
    transform: "translate(0 -0.007)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.6894bd68b2a1ff8fb3bb2bd917f4285e.svg";
export { ForwardRef as ReactComponent };